import { paths } from "@/App";
import EmptyState from "@/lib/components/EmptyState";
import { IconError404 } from "@tabler/icons-react";
import { useNavigate } from "react-router";

function NotFound() {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate(paths.root());
  };

  return (
    <EmptyState
      icon={<IconError404 size={24} />}
      header={
        <span>
          Oops! Page not found.
          <br />
        </span>
      }
      subHeader={
        <span>It seems like the page you are looking for does not exist.</span>
      }
      primaryActionLabel="Go to Homepage"
      primaryActionOnClick={handleGoHome}
    />
  );
}

export default NotFound;
